var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuspendedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#D86060"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    fillRule: "nonzero",
    d: "M27.69 27.023L28.485 7h-7.11l.888 20.023h5.427zM24.977 39c1.122 0 2.074-.384 2.853-1.153.78-.768 1.17-1.68 1.17-2.734 0-1.055-.39-1.959-1.17-2.712-.78-.753-1.73-1.13-2.853-1.13-1.092 0-2.028.377-2.807 1.13-.78.753-1.17 1.657-1.17 2.712 0 1.055.39 1.966 1.17 2.734.78.769 1.715 1.153 2.807 1.153z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspendedIcon);
export default __webpack_public_path__ + "static/media/suspended-icon.07f114bf13d848bf3e4524c7c9ac51a2.svg";
export { ForwardRef as ReactComponent };